<template functional>
  <div
    class="base-card"
    :class="[...(Array.isArray(data.class) ? data.class : [data.class]), data.staticClass]"
    :ref="data.ref"
    :style="[...(Array.isArray(data.style) ? data.style : [data.style]), data.staticStyle]"
    v-bind="props"
    v-on="listeners"
  >
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseCard",
});
</script>
